import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import Reporting from '../views/Reports';
import Login from '../views/Login';
import Clients from '../views/Clients';
import Roles from '../views/Roles/Roles';
import StrategyReporting from '../views/StrategyReporting';
import StrategyReporting2 from '../views/StrategyReporting2';
import HealthScore from '../views/HealthScore.vue';

Vue.use(VueRouter);

const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters['authStore/isAuthenticated']) {
        next()
        return
    }
    next('/')
}

const ifAuthenticated = (to, from, next) => {
    if (store.getters['authStore/isAuthenticated']) {
        next()
        return
    }
    next('/login')
}

const router = new VueRouter({
    routes: [{
        path: '*',
        redirect: '/reporting'
    },
        {
            path: '/login',
            component: Login,
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/reporting',
            component: Reporting,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/clients',
            component: Clients,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/health-score/:clientId',
            component: HealthScore,
            props: true,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/reporting2',
            component: StrategyReporting,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/reporting3',
            component: StrategyReporting2,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/roles',
            component: Roles,
            beforeEnter: ifAuthenticated
        }
    ]
});

Vue.mixin({
    router
});

export default router;
